import store from 'redux/store';

/* @ngInject */
export default function NvGoogleLocationAutocomplete(
  $timeout,
  $translate,
) {
  return {
    restrict: 'A',
    scope: {
      name: '=',
      required: '=',
      readonly: '=',
      triggerSave: '&',
      locationModel: '=',
      readonlyWarning: '=',
    },
    controller: function ctrl($scope, $element, $attrs) {
'ngInject';
      const VALIDATION_LOCATION_MESSAGE = 'VALIDATION.LOCATION';

      const vm = this;
      vm.touchedInput = false;
      vm.focusedInput = false;
      vm.pressedEnterKey = false;
      vm.invalid = !vm.locationModel;
      vm.selectedValidAddress = true;
      vm.tempValue = vm.locationModel;
      vm.autocompleteElement = null;

      function loadGoogleMapsScript(key) {
        if (window.google?.maps) return Promise.resolve();

        if (document.getElementById('google_script')) {
          return new Promise((resolve) => {
            const check = setInterval(() => {
              if (window.google?.maps) {
                clearInterval(check);
                resolve();
              }
            }, 100);
          });
        }

        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.id = 'google_script';
          script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&loading=async`;
          script.async = true;
          script.defer = true;
          script.onload = function () { resolve(); };
          script.onerror = function () { reject(new Error('Failed to load Google Maps API')); };
          document.head.appendChild(script);
        });
      }

      vm.locationAutocomplete = function () {
        const container = $element.find('.autocomplete-container').get(0);
        if (!container) return;

        google.maps.importLibrary('places').then((placesLib) => {
          const element = new placesLib.PlaceAutocompleteElement({
            includedPrimaryTypes: ['(cities)'],
          });

          element.placeholder = $translate.instant('PROFILE.LOCATION_PLACEHOLDER');

          element.addEventListener('gmp-select', (event) => {
            const { placePrediction } = event;
            const place = placePrediction.toPlace();
            place.fetchFields({ fields: ['formattedAddress'] }).then(() => {
              $timeout(() => {
                if (!vm.pressedEnterKey) {
                  vm.selectedValidAddress = true;
                  vm.tempValue = place.formattedAddress;
                  save();
                }
              });
            });
          });

          element.addEventListener('input', () => {
            $timeout(() => {
              const input = element.shadowRoot
                ? element.shadowRoot.querySelector('input')
                : element.querySelector && element.querySelector('input');
              const value = input ? input.value : '';
              vm.tempValue = value;
              vm.selectedValidAddress = !value;
              if (vm.required) {
                vm.invalid = !value;
              }
            });
          });

          container.appendChild(element);
          vm.autocompleteElement = element;

          if (vm.locationModel) {
            const input = element.shadowRoot
              ? element.shadowRoot.querySelector('input')
              : element.querySelector && element.querySelector('input');
            if (input) input.value = vm.locationModel;
          }
        });
      };

      const state = store.getState();
      const googleKey = state.app.configKey.google;

      loadGoogleMapsScript(googleKey).then(() => {
        vm.locationAutocomplete();
      });

      vm.handleBlur = function ($event) {
        touchInput();

        if (vm.selectedValidAddress) {
          if (vm.required) {
            if (vm.tempValue) {
              save();
            }
          } else {
            save();
          }
        }
      };

      vm.handleKeydown = function ($event) {
        $event.stopPropagation();

        if ($event && $event.keyCode === 13) {
          touchInput();
          vm.pressedEnterKey = true;

          if (vm.selectedValidAddress) {
            save();
          }
        } else {
          vm.pressedEnterKey = false;
        }
      };

      vm.handleFocus = function () {
        vm.focusedInput = true;
      };

      vm.getPopoverIsOpen = function () {
        const nonReadOnlyIsOpen = (
          vm.selectedValidAddress === false
          || (vm.required && !vm.tempValue)
        ) && vm.touchedInput;

        return vm.readonly ? vm.focusedInput : nonReadOnlyIsOpen;
      };

      vm.getPopoverMessage = function () {
        const requiredPopoverMessage = vm.tempValue ? VALIDATION_LOCATION_MESSAGE : 'VALIDATION.REQUIRED';

        const nonReadonlyMessage = vm.required ? requiredPopoverMessage : VALIDATION_LOCATION_MESSAGE;

        return vm.readonly ? vm.readonlyWarning : $translate.instant(nonReadonlyMessage);
      };

      function save() {
        vm.locationModel = vm.tempValue;

        $timeout(() => {
          vm.triggerSave();
        }, 500);
      }

      function touchInput() {
        vm.focusedInput = false;

        $timeout(() => {
          vm.touchedInput = true;
        }, 500);
      }
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'learner_profiles/templates/nv-google-location-autocomplete.html',
  };
}
